// firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY || "YOUR_KEY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN || "YOUR_DOMAIN",
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID || "YOUR_ID",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDERID || "YOUR_SENDER_ID",
  appId: process.env.REACT_APP_FIREBASE_APPID || "YOUR_APP_ID",
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
